module.exports = __webpack_public_path__ + "img/novoeight_icon_white.4e6da88c.svg";